<template>
    <div>
        <div class="banner1">
            <img src="../assets/img/banner4.jpg" alt="banner" />
        </div>

        <div class="block">
            <div class="center">
                <div class="left_bar">
                    <div class="title">新闻中心</div>
                    <ul>
                        <li><a href="#">媒体看凯纳</a></li>
                        <li><a href="#">行业新闻</a></li>
                        <li><a href="#">企业动态</a></li>
                        <li><a href="#">通知公告</a></li>
                    </ul>
                </div>
                <div class="right_contnet">
                    <h2>媒体看凯纳</h2>
                    <div id="article_list">
                        <ul>
                            <li v-for="(article, index) in article_list" :key="index" :id="article.uuid"><span class="title"><a href="javascript:void(0);" @click.stop="article_view(article.deptId)"><i class="icon icon_arrow"></i>{{ article.contentTitle }}</a></span><span class="date">{{ article.contentDatetime }}</span></li>
                        </ul>
                    </div>
                    <div class="page">
                        <a href="javascript:void(0);" @click.stop="page('first')">首页</a>
                        <a href="javascript:void(0);" @click.stop="page('pre')">上一页</a>
                        <a href="javascript:void(0);" @click.stop="page('next')">下一页</a>
                        <a href="javascript:void(0);" @click.stop="page('last')">尾页</a>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>

export default {
    name: 'Home',
    data() {
        return {
            title: '公司简介',
            sub_title: '',
            windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight, //实时屏幕高度

            //翻页
            cur_page: 1, //当前页
            page_size: 20, //每页显示数

            total_page : '', //总页数
            total_all : '', //总数据
            page_pre : '', //上一页
            page_next : '', //下一页
            jump_page : '', //跳转页面默认值

            article_list: '',
        };
    },
    created() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    },
    mounted() {
        window.onresize = () => {
            //页面改变尺寸时
            return (() => {
                this.windowWidth = document.documentElement.clientWidth;
                this.windowHeight = document.documentElement.clientHeight;
            })();
        };
    },
    methods: {
        goTo(e) {
            this.$router.push(e);
        },
        article_view( uuid ) {  //带uuid跳转详情页面
            this.$router.push({
                path: "ArticleView",
                query: { uuid: uuid },
            });
        },
        page(e) {
            alert( e );
            //分页参数
            if( e == 'first'){
                //首页
                this.article_list_date(
                    1,
                    this.page_size,
                );
            } else if (e == "pre") {
                //上一页
                this.article_list_date(
                    this.cur_page - 1,
                    this.page_size,
                );
            } else if (e == "next") {
                //下一页
                this.article_list_date(
                    this.cur_page + 1,
                    this.page_size,
                );
            } else if( e == 'last' ){
                //尾页
                this.article_list_date(
                    this.total_page,
                    this.page_size,
                );
            }else if( e == 'jump' ){
                //跳转页面
                if (this.jump_page <= this.total_page && this.jump_page > 0) {
                    this.article_list_date(
                        this.jump_page,
                        this.page_size,
                    );
                }else{
                    this.jump_page = this.cur_page;
                    this.message_tips_state = true;
                    this.message_tips_text = "No more data";
                    setTimeout(() => {
                        this.message_tips_state = false;
                    }, 2000);
                };
            };
        },
        test_data(){ //文章分类显示
            test({
                cur_page : 1,
                page_size : 20
            }).then((res) => {
                console.log( res );
                this.article_list = res.rows;
            });
        },
    },
};
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/XinWenZhongXin.vue